import {isDebug} from "../appConfig";

export const mPrint = (message?: any, ...optionalParams: any[]) => {
    isDebug && console.log("[PE] =>", message, ...optionalParams)
}
